import { observer } from "mobx-react-lite";
import React from "react";
import OrderArea from "./OrderArea";
import BottomArea from "./BottomArea";

interface TotalInfoCardProps {}

const TotalInfoCard: React.FC<TotalInfoCardProps> = function (props) {
    return (
        <div className="total-info-card">
            <OrderArea />
            <BottomArea />
        </div>
    );
};

export default observer(TotalInfoCard);
